import { useRef, MutableRefObject } from 'react'

export interface UseAuthCounterReturn {
  counterRef: MutableRefObject<number>
}

export const useAuthCounter = (): UseAuthCounterReturn => {
  const counterRef = useRef(0)

  return { counterRef }
}
